
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/dashboard",
      function () {
        return require("private-next-pages/app/dashboard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/dashboard"])
      });
    }
  